<template>
  <div v-if="isShow" style="height: 3.4rem">

    <div class="footer" id="footer" :style="{bottom: bottom}">

      <div  style="text-align: center;position: absolute;bottom: -2px;left: 50%;margin-left: -135px">
        <jsBarcode :user_id="this.$store.getters.getUserInfo.id" :line-color="'#a6a6a6'" :background="'white'"></jsBarcode>
      </div>

      <div v-for="(item, index) in resultItem" :key="index" class="item" @touchend="routerP(item.routerName)"
           @mouseup="routerP(item.routerName)" :class="{'active': $route.name === item.routerName}">
        <div>
          <template v-if="item.img">
            <img class="tabbar-img" :src="item.activeImg" v-if="$route.name === item.routerName">
            <img class="tabbar-img" :src="item.img" v-else>

          </template>

          <van-icon v-else class="item_icon" :name="item.icon" :dot="item.isDot"/>
          <div>{{item.title}}</div>
        </div>
      </div>

    </div>

  </div>
</template>

<script type="text/ecmascript-6">

import jsBarcode from '../../views/common/jsBarcode'

export default {
  components: {jsBarcode},
  computed: {
    isShow () {
      return this.items.map(i => i.routerName).indexOf(this.$route.name) > -1
    }
  },
  watch: {
  },

  data () {
    return {
      viewHeight: 0,
      bottom: '0rem',
      resultItem: [],
      items: [
        {
          title: '首页',
          routerName: 'home',
          icon: 'wap-home-o',
          isDot: false

        },
        {
          title: '活动',
          routerName: 'active',
          icon: 'flag-o',
          isDot: false

        },
        // {
        //   title: '消息',
        //   routerName: 'message',
        //   icon: 'chat-o',
        //   isDot: false

        // },
        {
          title: '我的',
          routerName: 'mine2',
          icon: 'user-o',
          isDot: false

        }
      ],
      items1: [
        {
          title: '首页',
          routerName: 'home',
          icon: 'wap-home-o',
          isDot: false,
          img: require('@/images/tabbar/home.png'),
          activeImg: require('@/images/tabbar/home-active.png')
        },
        {
          title: '活动',
          routerName: 'active',
          icon: 'flag-o',
          isDot: false,
          img: require('@/images/tabbar/activity.png'),
          activeImg: require('@/images/tabbar/activity-active.png')
        },
        {
          title: '消息',
          routerName: 'message',
          icon: 'chat-o',
          isDot: false,
          img: require('@/images/tabbar/message.png'),
          activeImg: require('@/images/tabbar/message-active.png')
        },
        {
          title: '我的',
          routerName: 'mine2',
          icon: 'user-o',
          isDot: false,
          activeImg: require('@/images/tabbar/mine-active.png'),
          img: require('@/images/tabbar/mine.png')
        }
      ]
    }
  },
  mounted () {
    if (this.$store.getters.getTemplateType === 1) {
      this.resultItem = this.items1
    } else {
      this.resultItem = this.items
    }
  },
  methods: {
    routerP (name) {
      this.$router.push({name: name})
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.footer {
  width: 100%;
  height: 3.4rem;
  display: flex;
  font-size: 0.85rem;
  position: fixed;
  left: 0px;
  z-index:2;
  background-color: #FFFFFF;
  line-height: 1.2;
  .item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFFFFF;
    color: #666666;
    text-align: center;

    .item_icon {
      font-size: 1.6rem;
    }

    span {
      color: #666666;
    }
  }

  .active {
    color: @theme-color;
    font-weight: bold;
  }
  .tabbar-img{
    width:2rem;
    height:2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/my-footer.vue